import jquery from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

/**
 * checkbox/radioの回答イベント
 */
export default class EFOcats_event_box_change extends EFOcats_event_core {
  /**
   * イベントための事前の仕込み
   */
  init() {
    // 特に処理無し
  }

  /**
   * イベント本体をセット
   */
  event() {
    this.$('body').on('change', '.box-label input', event => {
      const element = event.currentTarget;
      const type = jquery(element).attr('type');
      if (type === 'radio') {
        jquery(element).parents('.inner').find('.active').removeClass('active');
        jquery(element).parents('.box-label').addClass('active');
      } else if (jquery(element).is(':checked')) {
        jquery(element).parents('.box-label').addClass('active');
      } else {
        jquery(element).parents('.box-label').removeClass('active');
      }
    });
  }
}
